import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { StorageService } from './storage.service';

@Injectable()
export class AuthService {
  constructor(public userService: UserService, public storageService: StorageService) {}

  public isAuthenticated(): boolean {
    const token = this.userService.getapitoken();
    const date = new Date().getTime();

    return token !== undefined && token !== null && token.expires > date;
  }
}
